<template>
    <rkm-table
        :fields="fields"
        :filter="model.filter"
        :items="items"
        ref="RkmTable"
    >
        <template v-slot:filters>
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidade"
                        disabled
                        label="Unidade"
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.infraestrutura"
                        disabled
                        label="Local de atendimento"
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        label="Buscar"
                        placeholder="Digite para buscar"
                        v-model="model.filter"
                    />
                </rkm-col>
            </rkm-row>
        </template>

        <template v-slot:cell(actions)="row">
            <rkm-button
                @click="edit(row.item)"
                color="primary"
                authorize="update-painel-senha-opcao-chamada"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(row.item)"
                color="danger"
                authorize="destroy-painel-senha-opcao-chamada"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        fields() {
            return [
                { key: 'centroCusto.setor.nome', label: 'Setor', sortable: true },
                { key: 'tela.nome', label: 'Tela', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
    },
    created() {
        this.repositories = {
            opcaoChamada: this.getConectaSusRepository('painelSenha.opcaoChamada')
        }
    },
    data: () => ({
        form: {
            unidade: [],
            infraestrutura: [],
        },
        items: [],
        model: {
            filter: null,
            unidadeId: null,
            infraestruturaId: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            const request = {
                with: [
                    'centroCusto.setor',
                    'tela',
                ],
            }

            this.repositories.opcaoChamada.index(request)
                .then(response => {
                    this.form.unidade =  [{
                        id: this.lotacao.infraestrutura.unidade.id,
                        nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
                    }]

                    this.form.infraestrutura = [{
                        id: this.lotacao.infraestrutura.id,
                        nome: this.lotacao.infraestrutura.nome,
                    }]

                    this.items = response.data

                    this.model.unidadeId = this.lotacao.infraestrutura.unidade.id
                    this.model.infraestruturaId = this.lotacao.infraestrutura.id
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        edit(item) {
            this.$router.push({ name: 'painel-senha-opcao-chamada-edit', params: { id: item.id } })
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.opcaoChamada.destroy(item.id)
                .then(() => this.items.splice(this.items.findIndex(i => i.id === item.id), 1))

            this.showDeleteConfirmation('Deseja realmente excluir a opção de chamada?', destroy, this.handleError)
        },
    },
    mixins: [ error, repository ],
    mounted() {
        this.load()
    },
}
</script>